import { Form } from 'antd';
import { z } from 'zod';
import { useNavigate } from 'react-router-dom';
import { useMessage } from '@context/MessageProvider';
import { signupSchema } from '@validators/outside.schema';
import { useSignupMutation } from './useAuthMutations';
import { isMacOS } from '@utils/osDetection';

export const useSignup = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { showMessage } = useMessage();
    const signupMutation = useSignupMutation();

    const onFinish = async (values) => {
        if (signupMutation.isPending) return;
        try {
            const mappedValues = {
                name: values.signup_f1,
                email: values.signup_f2,
                phone: values.signup_f3,
                password: values.signup_f4,
                confirmPassword: values.signup_f5,
            };
            const parsedValues = signupSchema.parse(mappedValues);
            await signupMutation.mutateAsync({
                name: parsedValues.name,
                email: parsedValues.email,
                phone: parsedValues.phone,
                password: parsedValues.password,
            });
            navigate(`/verify-email?email=${encodeURIComponent(parsedValues.email)}`);
        } catch (error) {
            if (error instanceof z.ZodError && Array.isArray(error.errors)) {
                const fieldErrors = {};
                error.errors.forEach((err) => {
                    const path = err.path?.[0];
                    if (path) fieldErrors[path] = err.message;
                });
                const formFieldMap = {
                    name: 'signup_f1',
                    email: 'signup_f2',
                    phone: 'signup_f3',
                    password: 'signup_f4',
                    confirmPassword: 'signup_f5',
                };
                form.setFields(
                    Object.keys(fieldErrors).map((field) => ({
                        name: formFieldMap[field] || field,
                        errors: [fieldErrors[field]],
                    })),
                );
            } else {
                throw error;
            }
        }
    };

    const handleSubmitClick = () => {
        form.validateFields()
            .then((values) => onFinish(values))
            .catch(() => {});
    };

    const handleGoogle = () => {};
    const handleApple = () => {};

    return {
        form,
        loading: signupMutation.isPending,
        onFinish,
        handleSubmitClick,
        handleGoogle,
        handleApple,
        isMac: isMacOS(),
    };
};
